const getters = {
  loginData: (state) => state.loginData,
  accessToken: state => state.accessToken,
  keepAlive: state => state.keepAlive
};

export default getters;
